import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import moment from "moment";
import { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { CHANGE_PLAN_START_DATE } from "./graphql";

const ChangeStartDateView = ({ plan, onCompleted }) => {
  const [startDate, setStartDate] = useState(
    new Date(plan.startDate).toISOString().split("T")[0],
  );
  const [changeStartDate, changeStartDateRes] = useMutation(
    CHANGE_PLAN_START_DATE,
    {
      variables: { planId: plan.id, startDate: new Date(startDate) },
      onCompleted(res) {
        Alert("success", "Updated.");
        if (onCompleted) onCompleted(res.changeProductionPlanStartDate.plan);
      },
      onError(error) {
        Alert("error", error.message);
      },
      refetchQueries: ["FETCH_PREV_PLANS"],
    },
  );

  return (
    <div className="text-sm">
      <div>
        Note that changing the plan start date will effect the later plans.
      </div>

      <div className="flex items-center space-x-2 mt-6">
        <label htmlFor="">Start Date: </label>
        <span>{moment(plan.startDate).format("YYYY-MM-DD")}</span>
        <BsArrowRight />

        <input
          className="border px-2 py-1 rounded-lg"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </div>

      <Button
        className="mt-6"
        onClick={changeStartDate}
        loading={changeStartDateRes.loading}
        primary
      >
        Confirm
      </Button>
    </div>
  );
};

export default ChangeStartDateView;
